import { globalServices } from "../Axios/GlobalService";
import { ServiceUrl } from "../Helpers/Constants";
import { BCAddCommentRequest } from "../Interfaces/BCAddCommentRequest";
import { BCAddVerbruikRequest } from "../Interfaces/BCAddVerbruikRequest";
import { BCCustomer } from "../Interfaces/BCCustomer";
import { BCCustomValues } from "../Interfaces/BCCustomValues";
import { BCDeleteVerbruikRequest } from "../Interfaces/BCDeleteverbruikRequest";
import { BCDocumentAttachment } from "../Interfaces/BCDocumentAttachment";
import { BCDownloadDocument } from "../Interfaces/BCDownloadDocument";
import { BCItem } from "../Interfaces/BCItem";
import { BCNewOrderRequest } from "../Interfaces/BCNewOrderRequest";
import { BCResource } from "../Interfaces/BCResource";
import { BCServiceComment } from "../Interfaces/BCServiceComment";
import { BCServiceContact } from "../Interfaces/BCServiceContact";
import { BCServiceHistory } from "../Interfaces/BCServiceHistory";
import { BCServiceInfoRequest } from "../Interfaces/BCServiceInfoRequest";
import { BCServiceItem } from "../Interfaces/BCServiceItem";
import { BCServiceItemLine } from "../Interfaces/BCServiceItemLine";
import { BCServiceItemLog } from "../Interfaces/BCServiceItemLog";
import { BCServiceLine } from "../Interfaces/BCServiceLine";
import { BCServiceOrder } from "../Interfaces/BCServiceOrder";
import { BCServicePlanning } from "../Interfaces/BCServicePlanning";
import { BCSetServiceOrderTechDescrRequest } from "../Interfaces/BCSetServiceOrderTechDescrRequest";
import { BCShippingAddress } from "../Interfaces/BCShippingAddress";
import { BCTimeRegistration } from "../Interfaces/BCTimeRegistration";
import { BCTimeRegistrationRequest } from "../Interfaces/BCTimeRegistrationRequest";

export const DataService = {
    getCustomers,
    getCustomTaken,
    getItems,
    getResources,
    getServiceItems,
    getLinesForOrder,
    getServiceItemLine,
    getLogs,
    getServiceLines,
    getServiceOrder,
    getServicePlanning,
    getTimeRegistrationsForOrder,
    getShippingAddresses,
    getServiceContacts,
    getServiceRemark,
    getServiceTechnicalDescription,
    setServiceTechnicalDescription,
    getServiceLineComments,
    getServiceHistory,

    addVerbruik,
    deleteVerbruik,
    addServiceOrder,
    saveServiceInfo,
    addTimeRegistration,
    addServiceComment,

    getAttachments,
    downloadAttachment,
    downloadServiceOrderPdf
}

function getCustomers() {
    return globalServices.get<BCCustomer[]>(
        `${ServiceUrl}BC/Customers`
    );
}
function getCustomTaken() {
    return globalServices.get<BCCustomValues[]>(
        `${ServiceUrl}BC/CustomTaken`
    );
}
function getItems() {
    return globalServices.get<BCItem[]>(
        `${ServiceUrl}BC/Items`
    );
}
function getResources() {
    return globalServices.get<BCResource[]>(
        `${ServiceUrl}BC/Resources`
    );
}
function getServiceItems(customerNo: string, shipToCode: string) {
    return globalServices.get<BCServiceItem[]>(
        `${ServiceUrl}BC/ServiceItems?customerNo=${customerNo}&shipToCode=${shipToCode}`
    );
}
function getLinesForOrder(orderNo: string) {
    return globalServices.get<BCServiceItemLine[]>(
        `${ServiceUrl}BC/LinesForOrder?orderNo=${orderNo}`
    );
}
function getServiceItemLine(orderNo: string, lineNo: number) {
    return globalServices.get<BCServiceItemLine>(
        `${ServiceUrl}BC/ServiceItemLine?orderNo=${orderNo}&lineNo=${lineNo}`
    );
}
function getLogs(serviceItemNo: string) {
    return globalServices.get<BCServiceItemLog[]>(
        `${ServiceUrl}BC/Logs?serviceItemNo=${serviceItemNo}`
    );
}
function getServiceLines(orderNo: string, itemLineNo: number) {
    return globalServices.get<BCServiceLine[]>(
        `${ServiceUrl}BC/ServiceLines?orderNo=${orderNo}&itemLineNo=${itemLineNo}`
    );
}
function getServiceOrder(orderNo: string) {
    return globalServices.get<BCServiceOrder>(
        `${ServiceUrl}BC/ServiceOrder?orderNo=${orderNo}`
    );
}
function getServicePlanning() {
    return globalServices.get<BCServicePlanning[]>(
        `${ServiceUrl}BC/ServicePlanning`
    );
}
function getTimeRegistrationsForOrder(orderNo: string) {
    return globalServices.get<BCTimeRegistration[]>(
        `${ServiceUrl}BC/TimeRegistrationsForOrder?orderNo=${orderNo}`
    );
}
function getShippingAddresses(customerNo: string) {
    return globalServices.get<BCShippingAddress[]>(
        `${ServiceUrl}BC/ShippingAddresses?customerNo=${customerNo}`
    );
}
function getServiceContacts(customerNo: string) {
    return globalServices.get<BCServiceContact[]>(
        `${ServiceUrl}BC/ServiceContacts?customerNo=${customerNo}`
    );
}
function getServiceRemark(orderNo: string) {
    return globalServices.get<string>(
        `${ServiceUrl}BC/ServiceRemark?orderNo=${orderNo}`
    );
}
function getServiceTechnicalDescription(orderNo: string) {
    return globalServices.get<string>(
        `${ServiceUrl}BC/ServiceTechDescription?orderNo=${orderNo}`
    );
}
function setServiceTechnicalDescription(req: BCSetServiceOrderTechDescrRequest) {
    return globalServices.post(
        `${ServiceUrl}BC/ServiceTechDescription`, req
    );
}
function getServiceLineComments(orderNo: string, serviceItemLineNo: number) {
    return globalServices.get<BCServiceComment[]>(
        `${ServiceUrl}BC/ServiceLineComments?orderNo=${orderNo}&serviceItemLineNo=${serviceItemLineNo}`
    );
}
function getServiceHistory(serviceItemNo: string) {
    return globalServices.get<BCServiceHistory[]>(
        `${ServiceUrl}BC/ServiceHistory?serviceItemNo=${serviceItemNo}`
    );
}


function addVerbruik(request: BCAddVerbruikRequest) {
    return globalServices.post(
        `${ServiceUrl}BC/AddVerbruik`, request
    );
}
function deleteVerbruik(request: BCDeleteVerbruikRequest) {
    return globalServices.post(
        `${ServiceUrl}BC/DeleteVerbruik`, request
    );
}
function addServiceOrder(request: BCNewOrderRequest) {
    return globalServices.post<string>(
        `${ServiceUrl}BC/AddServiceOrder`, request
    );
}
function saveServiceInfo(request: BCServiceInfoRequest) {
    return globalServices.post(
        `${ServiceUrl}BC/SaveServiceInfo`, request
    );
}
function addTimeRegistration(request: BCTimeRegistrationRequest) {
    return globalServices.post(
        `${ServiceUrl}BC/AddTimeRegistration`, request
    );
}
function addServiceComment(request: BCAddCommentRequest) {
    return globalServices.post(
        `${ServiceUrl}BC/AddServiceComment`, request
    );
}


function getAttachments(orderNo: string, lineNo: number) {
    return globalServices.get<BCDocumentAttachment[]>(
        `${ServiceUrl}BC/GetAttachments?orderNo=${orderNo}&lineNo=${lineNo}`
    );
}
function downloadAttachment(request: BCDownloadDocument) {
    return globalServices.post<string>(
        `${ServiceUrl}BC/DownloadAttachment`, request
    );
}
function downloadServiceOrderPdf(orderNo: string) {
    return globalServices.get<string>(
        `${ServiceUrl}BC/DownloadServiceOrderPdf?orderNo=${orderNo}`
    );
}